import { type LandingPageTestimonial } from '@/app/components/LandingPage/LandingPageTestimonials/types';

const stressTestimonials: LandingPageTestimonial[] = [
  {
    id: 'nima-s',
    image: {
      alt: 'business_hero_alt',
      src: 'stress/testimonial_1',
    },
    name: 'Nima S.',
    quote: 'stress_testimonial_quote_1',
    tag: 'stress_testimonial_tag_1',
  },
  {
    id: 'tricia-p',
    image: {
      alt: 'les_a_image_alt',
      src: 'stress/testimonial_2',
    },
    name: 'Tricia P.',
    quote: 'stress_testimonial_quote_2',
    tag: 'stress_testimonial_tag_2',
  },
  {
    id: 'hemang-k',
    image: {
      alt: 'stress_testimonial_alt_3',
      src: 'stress/testimonial_3_1',
    },
    name: 'Hemang K.',
    quote: 'stress_testimonial_quote_3',
    tag: 'stress_testimonial_tag_3',
  },
];

export default stressTestimonials;
